<template>
  <div>
    <v-layout row wrap fill-height>
      <v-flex xs12 fill-height>
        <!-- Player -->
        <v-card
          flat
          class="movie-player"
          width="100%"
          :height="$vuetify.breakpoint.width < 600 ? '40vh' : '60vh'"
        ></v-card>
      </v-flex>
      <v-flex xs12 class="pt-4">
        <v-divider class="primary"></v-divider>
        <v-card-text class="pa-0 ma-0 pt-4">
          <v-card-title class="headline pa-0 ma-0">
            <v-flex xs12 md8>
              <div class="primary--text">
                {{
                  meta.films[playerState.currentMovieIndex].title[$i18n.locale] ||
                  meta.films[playerState.currentMovieIndex].title.en ||
                  "Unknown Title"
                }}
              </div>
              
            </v-flex>
            <v-flex xs12 md4>
              <v-card-actions>
                <v-btn
                  class="primary primary--text"
                  dark
                  @click="$parent.$emit('addToCal')"
                  outline
                  flat
                  small
                  >{{ $t("screener.btn.add_to_cal") }}</v-btn
                >
                <v-btn
                  class="primary primary--text"
                  dark
                  @click="$parent.$emit('leaveScreening')"
                  outline
                  flat
                  small
                  >{{ $t("screener.btn.leave_screening") }}</v-btn
                >
              </v-card-actions>
            </v-flex>
          </v-card-title>
          <v-card-title primary-title class="pa-0 ma-0 pt-2 pl-1 pb-4">
            <v-flex xs12>
              <span 
              class="subheadline secondary--text ql-editor" 
              v-html="meta.films[playerState.currentMovieIndex].description[$i18n.locale] || meta.films[playerState.currentMovieIndex].description.en || 'No description available'">
            </span>
            
            </v-flex>
          </v-card-title>
        </v-card-text>
        <v-divider class="primary"></v-divider>
      </v-flex>
    </v-layout>
    <CastPlayer
      v-if="player && movieSourceUrl"
      :localPlayerInstance="player"
      :localPlayerState="playerState"
      :meta="metaDataForChromeCast"
      :sourceUrl="movieSourceUrl"
    />
    <Analytics
      v-if="player"
      ref="analytics"
      :screener="meta"
      :currentTime="player.currentTime"
      :currentFilmIndex="playerState.currentMovieIndex"
    ></Analytics>
  </div>
</template>
<script>
import Artplayer from "artplayer";
import * as hlsStream from "@/hlsStreamingHandler";
import Analytics from "@/components/screener/Analytics";
import { EventBus } from "@/event-bus";
import mux from "mux-embed";
import { getAuthHash } from "@/api/_manager";
import CastPlayer from "./CastPlayer.vue"
export default {
  name: "MoviePlayer",
  props: {
    meta: {
      type: Object,
      default: null,
    },
    playerState: {
      type: Object,
      default: null,
    },
    consumer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      player: null,
      hlsInstance: null,
      hlsAvailableResolutions: []
    };
  },
  components: {
    Analytics,
    CastPlayer
  },
  computed: {
    movieSourceUrl() {
      return this.meta.screener_urls[this.playerState.currentMovieIndex];
    },

    metaDataForChromeCast(){
      var meta_data = {};
      const current_film = this.meta.films[this.playerState.currentMovieIndex]
      meta_data.title = current_film.title;
      meta_data.description = current_film.description;
      return meta_data;
    },
    isSeekingBlocked() {
      return this.meta.event_configuration
        ? this.meta.event_configuration.no_skip
        : false;
    },
    authHeaders() {
      return JSON.stringify(getAuthHash(this.meta.screener_id));
    },
    availableSubtitles() {
      return this.meta.subtitles[
        this.playerState.currentMovieIndex
      ].map((subtitle) => ({
        name: subtitle.lang_subtitle,
        url: subtitle.src_subtitle,
        html: subtitle.lang_subtitle,
      }));
    },
    customIcons() {
      return {
        subtitle:
          '<i class="fa fa-cc" style="font-size: large;align-items: center;display: flex;float: left;justify-content: center;height: 36px;width: 36px;" ></i>',
        qualitySwitcher:
          '<i class="fa fa-cog" style="font-size: large;align-items: center;display: flex;float: left;justify-content: center;height: 36px;width: 36px;" ></i>'
      };
    },
  },
  mounted() {
    this.initialisePlayer();
  },

  methods: {
    async initialisePlayer() {
      /**
       * 1. Load all default configurations of player
       * 2. Configure all event listeners with its listeners
       * 3. Add watermark to player
       */
      await this.loadPlayer();
      this.addCustomControls();
      // this.addWaterMark(this.player);
      this.configureAllEventListeners(this.player);
    },


    /**
     *===========================================================================================
     *                               INITIALIZE PLAYER CONFIGS
     *===========================================================================================
     */
    /**
     * Initialize player with its configurations
     */
    loadPlayer() {
      let _this = this;
      return (this.player = new Artplayer({
        container: ".movie-player",
        autoMini: true,
        pip: true,
        autoplay: true,
        isLive: _this.isSeekingBlocked, // Use this flag to disable seeking
        hotkey: _this.isSeekingBlocked ? false : true, // Stop hotkeys if seeking is blocked for event
        url: _this.movieSourceUrl,
        fullscreen: true,
        whitelist:["*"],
        customType: {
          m3u8: function (video, url) {
            _this.hlsInstance = hlsStream.initialize(video, url,_this.authHeaders);
          },
        },
      }));
    },

   /**
    * As we are using hls streamings with player because of this, player doesn't
    * support some default controls like, quality-switcher,etc. But player provide
    * option to add custom controls and these controls are very effective and specific
    * to its use case.
    *
    * THIS FUNCTION IS RESPONSIBLE FOR CONFIGURING ALL CUSTOM CONTROLS
    */
    addCustomControls() {
      this.addSubtitleControls(this.player);
      //this.addCustomQualitySwitcher(this.player)
    },

    /**
     * This function is responsible to add company logo as
     * a watermark
     */
    addWaterMark(playerInstance) {
      playerInstance.layers.add({
        html: `<img style="width: 100px" src="${this.meta.company_logo}">`,
        style: {
          position: "absolute",
          top: "20px",
          right: "20px",
          opacity: ".9",
        },
      });
    },

    /**
     * Configure all event listners with its handeler
     */
    configureAllEventListeners(playerInstance) {
      let _this = this;
      playerInstance.on("ready", () => {
        _this.onReady(playerInstance);
      });
      playerInstance.on("video:ended", () => {
        _this.onVideoEnd(playerInstance);
      });
      playerInstance.on("video:timeupdate", () => {
        _this.handelTimeUpdate(playerInstance);
      });

      /**
       * EVENT BUSES
       */
      EventBus.$on("hls:availableResolutions", (payload) => {
        // Available resolutions will be calculated on every new HLS URL (sort of computed)
        _this.hlsAvailableResolutions = payload;
        _this.addCustomQualitySwitcher(_this.player)
      });

      //Show Notifications on full screen
      EventBus.$on("showSupportNotification", payload => {
        if(playerInstance.fullscreen){
          playerInstance.notice.show = payload.message;
        }
      });
    },


     /**
     *===========================================================================================
     *                               PLAYER EVENT HANDLERS
     *===========================================================================================
     */
    /**
     * Player Ready State handler
     */
    onReady(playerInstance) {
      playerInstance.seek = this.playerState.currentTime;
      this.reportAnalyticsToMux(playerInstance);
    },

    /**
     * Video end event listners
     */
    async onVideoEnd(playerInstance) {

      // Stop Analytics
      this.$refs.analytics.clearIntervalWhenDone(playerInstance);
      let nextMovieIndex = this.playerState.currentMovieIndex + 1;

      /**
       * If next index is not available the its simply mean movie
       * have been ended
       */
      if (!this.meta.screener_urls[nextMovieIndex]) {
        return this.$emit("movieStreamEnded");
      }

      await this.$store
        .dispatch("player/updateMovieIndex", {
          screener_id: this.meta.screener_id,
          currentMovieIndex: nextMovieIndex,
        })
        .then(async (response) => {
          await this.$store.dispatch("player/updateCurrentTime", {
            screener_id: this.meta.screener_id,
            currentTime: 0,
          });
          this.playerState.currentMovieIndex = nextMovieIndex;
          this.$emit("OnMovieIndexChange",nextMovieIndex);
          // playerInstance.switchUrl(
          //   this.movieSourceUrl,
          //   this.meta.films[nextMovieIndex].title
          // );
          // this.removeCustomControls(playerInstance)
          // this.addCustomControls()
        });
    },

    /**
     * Timeupdate Listner
     */
    handelTimeUpdate(playerInstance) {
      this.$store.dispatch("player/updateCurrentTime", {
        screener_id: this.meta.screener_id,
        currentTime: playerInstance.currentTime,
      });

      /**
       * HandelAnalytics
       */
      this.$refs.analytics.setIntervalIfNeeded(playerInstance);
    },

    /**
     *===========================================================================================
     *                               PLAYER CONFIGS CONTROLLER
     *===========================================================================================
    */

    handleHlsAvailableResolutions(payload) {
      let _this = this;
      this.player.controls.add({
        position: "right",
        name: 'quality-switcher',
        html: this.customIcons.qualitySwitcher,
        selector: payload,
        onSelect: function (item, $dom) {
          EventBus.$emit("hls:switchVideoResolution",{
            height: item.height
          });
          return _this.customIcons.qualitySwitcher;
        },
      });
    },

    reportAnalyticsToMux(playerInstance) {
      /**
       * Get art player instance
       */
      let video_instance = document.getElementsByClassName("art-video");

      mux.monitor(video_instance[0], {
        debug: false,
        // pass in the 'hls' instance and the 'Hls' constructor
        hlsjs: this.hlsInstance,
        Hls,
        data: {
          env_key: this.DEFINES.MUX_ENV_KEY, // required
          // Metadata fields
          player_name: "Movie Player", // any arbitrary string you want to use to identify this player
          player_init_time: playerInstance.currentTime,

          // Site Metadata
          viewer_user_id: this.consumer.id, // ex: '12345'
          sub_property_id: this.meta.screener_id, // ex: 'cus-1

          // Video Metadata
          video_id:
            this.meta.films[this.playerState.currentMovieIndex].screener_media,
          video_title: this.meta.title,
        },
      });
    },


    /**
     *===========================================================================================
     *                               PLAYER CUSTOM CONTROLLERs
     *===========================================================================================
    */

    /** SUBTITLE HANDLERS  */
    addSubtitleControls(playerInstance) {

      let _this = this;

      //1. Do not add controls if subtitle is not available
      if(!this.availableSubtitles.length){
        return;
      }

      // 2. Set subtitle if available in player state
      if(this.playerState.subtitle_lang){
        this.switchSubtitle(this.playerState.subtitle_lang, playerInstance)
      }

      //3. Enable Custom controls with switching option
      playerInstance.controls.add({
        position: "right",
        name: 'subtitle',
        html: this.customIcons.subtitle,
        selector: this.availableSubtitles,
        onSelect: function (item, $dom) {
          _this.switchSubtitle(item.name, playerInstance);
          return _this.customIcons.subtitle;
        },
      });


    },

    switchSubtitle(nextSubtitleLanguage, playerInstance) {

      let subtitle = this.availableSubtitles.find(subtitle => subtitle.name==nextSubtitleLanguage)

      // Update Only if subtitle is available
      if(!subtitle){
        return;
      }

      // 1. Switch in player
      playerInstance.subtitle.switch(subtitle.url, {
            default: true,
            html: subtitle.html,
      });

      //2. Update in state
      this.$store.dispatch('player/updateScreenerSubtitle',{
        screener_id: this.meta.screener_id,
        subtitleLang: subtitle.name
      })
    },

    /**
     * Add quality switcher controls to player with its
     * default state
     */
    addCustomQualitySwitcher(playerInstance){

      let _this = this;
      //1. Do not add controls if resolutions are not available
      if(!this.hlsAvailableResolutions.length){
        return;
      }

      // 2. Set subtitle if available in player state
      if(this.playerState.resolution){
        this.switchQuality(this.playerState.resolution)
      }

      playerInstance.controls.add({
        position: "right",
        html: this.customIcons.qualitySwitcher,
        selector: this.hlsAvailableResolutions,
        onSelect: function (item, $dom) {
          _this.switchQuality(item.height)
          return _this.customIcons.qualitySwitcher;
        },
      });
    },

    /**
     * Switch quality and store it in state
     */
    switchQuality(newResolutionHeight){
      let resolution = this.hlsAvailableResolutions.find(resolution => resolution.height==newResolutionHeight)

      //1. Update Only if resolution is available
      if(!resolution){
        return;
      }

       EventBus.$emit("hls:switchVideoResolution",{
            height: resolution.height
      });

      //2. Update in state
      this.$store.dispatch('player/updateScreenerResolution',{
        screener_id: this.meta.screener_id,
        resolution: resolution.height
      })
    }
  },
};
</script>
<style scoped></style>
